import { TFunction } from 'react-i18next';
import { PropertyType } from '@/models/property.model';
import { StepType } from '@/models/step.model';

export const getStepTypeOptions = (t: TFunction) =>
  Object.values(StepType).map((value) => ({
    value,
    label: t(`step_type_${value.toLowerCase()}`),
  }));

export const getPropertyTypeOptions = (t: TFunction) =>
  Object.values(PropertyType).map((value) => ({
    value,
    label: t(`property_type_${value}`, { ns: 'common' }),
  }));
